<script lang="ts">
	import { format } from 'svelte-i18n';
	//Design system components
	import { ControlsContainer, Text, LabelListV2, SliderV2 } from '@Shelly/shelly-design-system';
	//Helpers
	import { capFirstChar } from 'src/helpers/utilities';
	import { gen2Request } from 'src/services/gen_2_http_reqs';
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	//Components
	import DeviceNotificationLabel from 'src/components/Sidepanel/DeviceNotificationLabel.svelte';
	import VirtualBooleanButton from 'src/components/DevicesSettings/VirtualComponents/Components/VirtualBooleanButton.svelte';
	//Types
	import type { Device } from 'src/types/Device';
	import type { VCInterfaceStatus } from 'src/types/VirtualComponents';
	import type { SettingRequest } from 'src/types/requests/settings/setting';

	export let device: Device, statuses: VCInterfaceStatus[];

	const _device = device;
	const changePosition = async (value: number) => {
		isLoading = true;
		valueBeforeSend = value;
		const res: SettingRequest = await gen2Request(device, 'Number.set', {
			id: statusBrightness.id,
			value,
		});
		if (!res?.isok) {
			valueBeforeSend = null;
			onSettingsResponse(res, device);
		}
		isLoading = false;
	};

	let isLoading = false;
	let valueBeforeSend: number = null;
	let statusToggle: VCInterfaceStatus;
	let statusBrightness: VCInterfaceStatus;
	let value = 0;

	$: if (statuses) {
		statusToggle = statuses.find((i) => /^(state)$/.test(i.role));
		statusBrightness = statuses.find((i) => /^(brightness)$/.test(i.role));
		value = valueBeforeSend !== null ? valueBeforeSend : statusBrightness?.rawValue || 0;
		if (!isLoading && valueBeforeSend !== null && statusBrightness?.rawValue == valueBeforeSend) {
			valueBeforeSend = null;
		}
	}
</script>

<div class="lable-list-wrapper-in-drawer-tab-content mb-s">
	<LabelListV2
		class="mb-l justify-content-center"
		size="m"
		backgroundColor="--color-1"
		data-prevent-drawer-swipe
		data-prevent-sidepanel-swipe
		a11yProps={{ isInteractive: true }}
		labelList={statuses.filter((i) => !/^(state|brightness)$/.test(i.role) || i?.sensor)}
		on:label-click={(e) => {
			e.stopPropagation();
		}}
	/>
</div>
<DeviceNotificationLabel deviceId={device?.id} />
{#if statusBrightness?.id}
	<div class="flex-full-height">
		<SliderV2
			id="slider-uf6eepf"
			a11yProps={{
				ariaLabel: 'Slider',
				ariaLabelValue: 'Value of slider',
			}}
			class="flex-full-height justify-content-center"
			title={capFirstChar($format('label_brightness', { default: 'brightness' }))}
			{value}
			step={Number(statusBrightness?.step || 1)}
			on:value_change={(e) => {
				changePosition(e.detail.value);
			}}
			unit={statusBrightness.unit || ''}
			{isLoading}
		/>
	</div>
{/if}
<div class="justify-content-end{statusBrightness?.id ? '' : ' flex-full-height'}">
	<ControlsContainer class="mt-s" color="color-0">
		<svelte:fragment slot="first">
			<VirtualBooleanButton
				isWide
				device={_device}
				componentID={statusToggle?.id}
				value={statusToggle?.event}
				useV2Components
				deviceButtonV2Props={{ size: 'l' }}
			/>
			<Text styleType="controls-large" class="mt-s text-bold"
				>{capFirstChar(
					statusToggle?.event
						? $format('label_action_turn_off', { default: 'turn off' })
						: $format('label_action_turn_on', { default: 'turn on' }),
				)}</Text
			>
		</svelte:fragment>
	</ControlsContainer>
</div>
